import { render, staticRenderFns } from "./PrePlanFileImport.vue?vue&type=template&id=48603fc4&"
import script from "./PrePlanFileImport.vue?vue&type=script&lang=ts&"
export * from "./PrePlanFileImport.vue?vue&type=script&lang=ts&"
import style0 from "./PrePlanFileImport.vue?vue&type=style&index=0&id=48603fc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports